import {
  CalendarFilled,
  CloseCircleOutlined,
  PhoneFilled,
} from "@ant-design/icons";
import GenderTag from "../misc/GenderTag";
import { Tag } from "antd";
import { Link } from "react-router";
import { Client } from "../../entities/interfaces/client";
import dayjs from "dayjs";

type ClientInfoProps = {
  client: Client;
};

type MembershipStatus = "ACTIVE" | "INACTIVE" | "NOT_AVAILABLE";

const ClientInfo = ({ client }: ClientInfoProps) => {
  const getMembershipStatus = (): MembershipStatus => {
    if (!client.membership) {
      return "NOT_AVAILABLE";
    } else if (client.membership.isActive) {
      return "ACTIVE";
    } else return "INACTIVE";
  };

  const membershipStatus = getMembershipStatus();

  const renderMembershipStatusTag = (status: MembershipStatus) => {
    switch (status) {
      case "ACTIVE":
        return <Tag color="green">Active</Tag>;
      case "INACTIVE":
        return <Tag color="red">Inactive</Tag>;
      case "NOT_AVAILABLE":
        return <Tag color="red">Not Available</Tag>;
      default:
        return <Tag color="red">Not Available</Tag>;
    }
  };

  return (
    <div className="">
      <div className="flex items-center gap-5">
        <div className="border-r pr-3">
          <div className="flex items-center gap-3 mb-4">
            <p className="text-base font-semibold ">{client.name}</p>
            <GenderTag gender={client.gender} />
          </div>
          <p className="text-gray-500">
            <PhoneFilled className="mr-2" />
            {client.phone}
          </p>
        </div>
        <div className="border-r pr-3">
          <div className="mb-4 flex items-center gap-3  ">
            <p className="text-base font-semibold ">Membership</p>
            {renderMembershipStatusTag(membershipStatus)}
          </div>
          <p className="text-gray-500">
            <CalendarFilled className="mr-2" />
            Ends on{" "}
            {membershipStatus === "ACTIVE"
              ? dayjs(client.membership.endDate).format("DD/MM/YYYY")
              : "---"}
          </p>
        </div>
        <div className=" pr-3">
          <p className="text-base font-semibold mb-4 ">Last visited</p>
          <p className="text-gray-500">---</p>
        </div>
      </div>
    </div>
  );
};

export default ClientInfo;
